const actions = {
  LIST_ELIGIBLE_MERCHANTS_BEGIN: 'LIST_ELIGIBLE_MERCHANTS_BEGIN',
  LIST_ELIGIBLE_MERCHANTS_SUCCESS: 'LIST_ELIGIBLE_MERCHANTS_SUCCESS',
  LIST_ELIGIBLE_MERCHANTS_ERR: 'LIST_ELIGIBLE_MERCHANTS_ERR',

  PAY_MERCHANT_BONUSES_BEGIN: 'PAY_MERCHANT_BONUSES_BEGIN',
  PAY_MERCHANT_BONUSES_SUCCESS: 'PAY_MERCHANT_BONUSES_SUCCESS',
  PAY_MERCHANT_BONUSES_ERR: 'PAY_MERCHANT_BONUSES_ERR',

  listEligibleMerchantsBegin: () => {
    return { type: actions.LIST_ELIGIBLE_MERCHANTS_BEGIN };
  },

  listEligibleMerchantsSuccess: (data) => {
    return { type: actions.LIST_ELIGIBLE_MERCHANTS_SUCCESS, data };
  },

  listEligibleMerchantsErr: (err) => {
    return { type: actions.LIST_ELIGIBLE_MERCHANTS_ERR, err };
  },

  payMerchantBonusesBegin: () => {
    return { type: actions.PAY_MERCHANT_BONUSES_BEGIN };
  },

  payMerchantBonusesSuccess: (data) => {
    return { type: actions.PAY_MERCHANT_BONUSES_SUCCESS, data };
  },

  payMerchantBonusesErr: (err) => {
    return { type: actions.PAY_MERCHANT_BONUSES_ERR, err };
  },
};

export default actions;
